var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.843 2.616a1 1 0 0 1 1.316.949V14.88a1 1 0 0 1-.684.949l-4.833 1.61a1 1 0 0 1-.633 0l-4.367-1.455a1 1 0 0 0-.633 0l-4.2 1.4a1 1 0 0 1-1.317-.948V5.12a1 1 0 0 1 .684-.948L8.009 2.56a1 1 0 0 1 .633 0l4.367 1.456a1 1 0 0 0 .633 0l4.2-1.4Zm-5.35 2.985L9.158 4.49v9.91l3.333 1.11V5.6Zm1.666 9.91 3.333-1.111V4.49L14.16 5.6v9.91ZM7.492 14.4V4.49L4.16 5.6v9.91l3.333-1.11Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMap);
export default __webpack_public_path__ + "static/media/view_map.730bc1c0b1fc9d267c61296468ec2e94.svg";
export { ForwardRef as ReactComponent };